import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createFarmOrganicFertilizerProduction } from "services";

import { CREATE_FARM_ORGANIC_FERTILIZER_PRODUCTION, GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, GET_FARM_ORGANIC_FERTILIZER_PRODUCTION } from "consts";

export const useCreateFarmOrganicFertilizerProduction = ({ farmId, year }: { farmId: string; year: number }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [CREATE_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId, year],
    mutationFn: createFarmOrganicFertilizerProduction,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
    },
  });
};
